import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        
        <h1 className="font-heading text-3xl font-bold text-foreground mb-2">Privacy Policy</h1>
        <p className="text-muted-foreground mb-8">Last updated: January 2026</p>
        
        <div className="prose prose-green dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground">1. Information We Collect</h2>
            <p className="text-muted-foreground">
              Fencepost collects information you provide directly, including:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Account information (email, farm name, location)</li>
              <li>Farm data (crops, livestock, garden layouts)</li>
              <li>Usage data (app interactions, preferences)</li>
              <li>Payment information (processed securely via Stripe)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">2. How We Use Your Information</h2>
            <p className="text-muted-foreground">We use your information to:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Provide personalized farm planning features</li>
              <li>Send weather alerts for your location</li>
              <li>Generate insights and suggestions for your farm</li>
              <li>Process subscription payments</li>
              <li>Improve our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">3. Data Storage & Security</h2>
            <p className="text-muted-foreground">
              Your data is stored securely using industry-standard encryption. We use MongoDB for data storage 
              and Stripe for payment processing. Your payment information is never stored on our servers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">4. Third-Party Services</h2>
            <p className="text-muted-foreground">We use the following third-party services:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li><strong>OpenAI</strong> - For generating suggestions and chat responses</li>
              <li><strong>OpenWeatherMap</strong> - For weather data and alerts</li>
              <li><strong>Stripe</strong> - For secure payment processing</li>
              <li><strong>USDA Market News</strong> - For market price data (optional)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">5. Your Rights</h2>
            <p className="text-muted-foreground">You have the right to:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Export your farm data</li>
              <li>Cancel your subscription at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">6. Data Retention</h2>
            <p className="text-muted-foreground">
              We retain your data for as long as your account is active. Upon account deletion, 
              we will remove your personal data within 30 days, except where required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">7. Contact Us</h2>
            <p className="text-muted-foreground">
              For privacy-related questions, contact us at: support@myfencepost.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
